import { Config } from './config';

export const config = global.__PRELOADED_CONFIG__ as Config;

__webpack_public_path__ = `${config.cdnDomain}${__webpack_public_path__}`;
